const l = (i) => ({
  wrapper: {
    backgroundColor: i.palette.common.blue20
  },
  heading: {
    color: i.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: i.typography.fontSize22
    }
  },
  description: {
    color: i.palette.common.grey300,
    "@media(max-width: 600px)": {
      fontSize: i.typography.fontSize14
    }
  },
  card: {
    display: "flex",
    flexDirection: "column",
    height: "inherit",
    padding: 0,
    boxShadow: "none",
    border: "none"
  },
  imgWrapper: {
    position: "relative"
  },
  bgImg: {
    backgroundColor: i.palette.common.blue100
  },
  duration: {
    position: "absolute",
    top: 12,
    right: 12,
    "[dir='rtl'] &": {
      direction: "ltr"
    }
  },
  label: {
    color: i.palette.common.blue400,
    "@media(max-width: 600px)": {
      minHeight: 40,
      fontSize: i.typography.fontSize14
    }
  },
  sliderWrapper: {
    display: "block",
    overflow: "hidden",
    "& .slick-slider": {
      position: "relative",
      display: "block",
      boxSizing: "border-box",
      userSelect: "none",
      touchAction: "pan-y",
      tapHighlightColor: "transparent"
    },
    "& .slick-list": {
      position: "relative",
      display: "block",
      overflow: "hidden",
      margin: 0,
      padding: 0,
      "&:focus": {
        outline: "none"
      },
      "&.dragging": {
        cursor: "hand"
      }
    },
    "& .slick-slider .slick-track, & .slick-slider .slick-list": {
      transform: "translate3d(0, 0, 0)"
    },
    "& .slick-track": {
      position: "relative",
      top: 0,
      left: 0,
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      flexWrap: "nowrap",
      alignItems: "stretch",
      "&:before, &:after": {
        display: "table",
        content: '""'
      },
      "&:after": {
        clear: "both"
      }
    },
    "& .slick-loading .slick-track": {
      visibility: "hidden"
    },
    "& .slick-slide": {
      display: "none",
      float: "left",
      height: "auto",
      minHeight: 1
    },
    "& [dir='rtl'] .slick-slide": {
      float: "right"
    },
    "& .slick-slide img": {
      display: "block"
    },
    "& .slick-slide.slick-loading img": {
      display: "none"
    },
    "& .slick-slide.dragging img": {
      pointerEvents: "none"
    },
    "& .slick-initialized .slick-slide": {
      display: "flex"
    },
    "& .slick-loading .slick-slide": {
      visibility: "hidden"
    },
    "& .slick-vertical .slick-slide": {
      display: "block",
      height: "auto",
      border: "1px solid transparent"
    },
    "& .slick-arrow.slick-hidden": {
      display: "none"
    },
    "& .slick-slide>div": {
      width: "100%",
      paddingLeft: 8,
      paddingRight: 8
    }
  },
  getQuoteCta: {
    "[dir='rtl'] &": {
      direction: "ltr"
    }
  }
}), o = l;
export {
  o as default
};
